/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Device { 
    id: string;
    programId: string;
    locationId: string;
    posId: string;
    deviceId: string;
    beaconId: string;
    type: Device.TypeEnum;
    name: string;
    lastConnectionAt?: string;
    createdAt: string;
    updatedAt: string;
    online?: boolean;
}
export namespace Device {
    export const TypeEnum = {
        Beacon: 'beacon',
        NfcReader: 'nfc_reader',
        Pos: 'pos'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


